import { BehaviorSubject } from 'rxjs';
import moment from 'moment';
import { updateUpdateTokenService } from '../shared/hooks/handleUpdateToken';

const isUserLoggedInSubject = new BehaviorSubject(false);

const userNameSubject = new BehaviorSubject(null);

export const companyData = () => {

    const isCompanyExist = () => {
        const companyId = localStorage.getItem('companyId');
        return !!companyId && companyId !== 'undefined' ? true : false;
    }

    const saveCompanyData = (activeCompanyDetails: any) => {
        localStorage.setItem('companyId', activeCompanyDetails?._id);
    }

    const getCompanyData = () => {
        const companyId = localStorage.getItem('companyId');
        return companyId;
    }

    return {
        getCompanyData,
        saveCompanyData,
        isCompanyExist
    }
}

const isUserLoggedIn = () => {
    return isUserLoggedInSubject.asObservable();
}

const userNameFunc = () => {
    return userNameSubject.asObservable();
}

const changeIsUserLoggedInSubject = (value) => {
    isUserLoggedInSubject.next(value);
}
const changeUserNameSubject = (value) => {
    userNameSubject.next(value);
}

export const getAccessToken = () => {
    const token = localStorage.getItem('token');
    return token ? token : null;
}

export const isAuthenticated = () => {
    const token = getAccessToken();
    // TODO: check tokenExpired
    // change this.
    return token ? true : false;
}

export const handleAuth = (userData: any) => {
    if (userData) {
        addToken(userData.token);
        localStorage.setItem('tokenExpiration', userData.tokenExpiration);
        localStorage.setItem('refreshToken', userData.refreshToken);
        localStorage.setItem('userData', JSON.stringify({
            userId: userData.userId || userData.user._id,
            name: userData.name || userData.user.name,
            email: userData.email || userData.user.email,
        }));
        companyData().saveCompanyData(userData.activeCompanyDetails);
        changeIsUserLoggedInSubject(true);
        changeUserNameSubject(userData.name || userData.user.name);
        // setProfile();
        const userProfile = {
            userId: userData.userId || userData.user._id,
            name: userData.name || userData.user.name,
            email: userData.email || userData.user.email,
        };
    } else {
        console.log('not autheticated');
    }
}

export const logoutAndRedirect = () => {
    localStorage.clear();
    changeIsUserLoggedInSubject(false);
    changeUserNameSubject(null);
    updateUpdateTokenService.clearRefreshIntervalDelay()
}

const addToken = (token) => {
    const today = moment().add(58, 'minutes').valueOf();
    localStorage.setItem('uuid', JSON.stringify(today));
    localStorage.setItem('token', token);
}
const userData = () => {
    const checkUser = isAuthenticated();
    isUserLoggedInSubject.next(checkUser);
    const loggedInUserData = JSON.parse(localStorage.getItem('userData') || '{}');
    changeUserNameSubject(loggedInUserData?.name);
}
userData();

export const authService = {
    isUserLoggedIn,
    userNameFunc,
    changeUserNameSubject,
    changeIsUserLoggedInSubject,
    addToken
}